import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { getFieldErrors } from "../helpers";
import { tryConfirmLogin } from "./authReducer";

export interface IUnit {
    _id: string;
    name: string;
    creatorUserId: string;
}

export interface IUnitsState {
    fetchingUnits: boolean;
    units: IUnit[];
    fetchUnitsErr: string | null;
}

const initialState = {
    fetchingUnits: false,
    units: [],
    fetchUnitsErr: null
} as IUnitsState;

const unitsSlice = createSlice({
    name: "units",
    initialState,
    reducers: {
        clearFetchUnitsErr: (state: IUnitsState) => {
            state.fetchUnitsErr = null;
        },
        fetchUnitsStart: (state: IUnitsState) => {
            state.fetchUnitsErr = null;
            state.fetchingUnits = true;
        },
        fetchUnitsPass: (state: IUnitsState, action: PayloadAction<IUnit[]>) => {
            state.fetchingUnits = false;
            state.units = action.payload;
        },
        fetchUnitsFail: (state: IUnitsState, action: PayloadAction<string>) => {
            state.fetchingUnits = false;
            state.fetchUnitsErr = action.payload;
        },
    }
});

export const {
    clearFetchUnitsErr,
    fetchUnitsStart,
    fetchUnitsPass,
    fetchUnitsFail,
} = unitsSlice.actions;

interface ITryFetchUnitsArg {
    authToken: string;
}

export const tryFetchUnits = createAsyncThunk('Units/tryFetchUnits', (arg: ITryFetchUnitsArg, { dispatch }) => {
    const endpoint = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/units`;

    const { authToken } = arg;

    dispatch(fetchUnitsStart());
    axios.get(endpoint, {
        headers: {
            'Content-Type': 'application/json',
        }
    }).then(res => {
        dispatch(fetchUnitsPass(res.data));
    }).catch(err => {
        const data = err?.response?.data;

        if (data?.err && (data.err === "Session expired")) {
            dispatch(tryConfirmLogin({authToken}));
            return;
        }
        let error = '';

        if (data?.err && typeof data?.err === typeof new String('')) {
            error = data.err;
        } else if (data?.errors) {
            error = getFieldErrors(data.errors)[0].msg;
        } else {
            error = 'Check your network connection.';
        }

        dispatch(fetchUnitsFail(error));
    });
});


export default unitsSlice.reducer;